import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import styled from "@yb/styled-px2rem";

const Wrap = styled.div`
	margin-bottom: 100px;
`;

const ContentWrap = styled.div`
	padding: 25px 15px;
`;

const AccordionArea = styled.ul<{border?: boolean}>`
	display: flex;
	flex-direction: column;
	${props => props.border && `border-top: 1px solid var(--line-color);`}
`;

const AccordionItem = styled.li<{isToggle?: boolean}>`
	margin-top: -1px;
	border-top: 1px solid transparent;
	border-bottom: 1px solid ${props => (props.isToggle ? "var(--emp-color)" : "var(--line-color)")};
	${props =>
		props.isToggle &&
		`
				border-top: 1px solid var(--emp-color);
			`}
`;
const AccordionContent = styled.div<{isToggle?: boolean}>`
	position: relative;
	padding: 15px 50px 15px 15px;
	cursor: pointer;

	${props =>
		props.isToggle &&
		`
		h5 {
			font-weight: bold;
		}
	`}
`;
const AccordionTitle = styled.h5`
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	gap: 10px;
	font-size: 17px;
	span {
		font-weight: bold;
	}
`;
const AccordionDetail = styled.div<{isActive: boolean}>`
	transition: height 0.5s ease;
	height: 0;
	opacity: 0;
	overflow: hidden;

	${props =>
		props.isActive &&
		`
			opacity: 1;
			height: auto;
	`}
`;
const AccordionMoreButton = styled.button<{isToggle: boolean}>`
	position: absolute;
	right: 0;
	top: 50%;
	padding: 0 22px 0 7px;
	margin-top: -4px;
	background-color: transparent;
	transform: translateY(-50%);

	&:after {
		display: block;
		width: 7px;
		height: 7px;
		border-top: 1px solid var(--emp-color);
		border-right: 1px solid var(--emp-color);
		font-size: 0px;
		transform: rotate(135deg);
		content: "";
	}

	${props =>
		props.isToggle &&
		`
		top: calc(50% + 5px);
		&:after {
			transform: rotate(-45deg);
		}
    `}
`;

const InputWrap = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 20px 15px;
	background-color: #f7f7f7;
	border-top: 1px solid var(--line-color);
	border-bottom: 1px solid var(--line-color);
	select {
		background-color: #fff;
	}
	> div {
		flex: 0 0 calc(50% - 5px);
	}
	+ div {
		margin: 20px 0;
	}
`;

const CalendarInput = styled.div`
	position: relative;
	background-color: #fff;
	input {
		position: relative;
		z-index: 1;
		background-color: transparent;
		&::placeholder {
			color: var(--default-color);
		}
	}
	i {
		position: absolute;
		right: 10px;
		top: 50%;
		z-index: 0;
		width: 20px;
		height: 20px;
		transform: translateY(-50%);
	}
`;

const CheckList = styled.ul`
	display: flex;
	flex-wrap: wrap;
	flex: 1 1 auto;
	gap: 5px;
	width: 100%;
	padding: 20px 15px;
	background-color: #f7f7f7;
	border-top: 1px solid var(--line-color);
	li {
		label {
			padding: 10px 15px;
		}
		input {
			&:checked + label {
				display: flex;
				align-items: center;
				gap: 10px;
				&::after {
					transform: translateY(-14%) rotate(45deg);
				}
			}
		}
	}
`;
const CheckListItem = styled.li`
	position: relative;
	input {
		position: absolute;
		top: 0;
		left: 0;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: 0;
		background-color: transparent;
		border: 0;

		&:checked {
			+ label {
				font-weight: bold;
				border-color: var(--emp-color);
				color: var(--emp-color);
				&::after {
					display: block;
					flex: 0 0 auto;
					width: 6px;
					height: 11px;
					border-right: 0.15rem solid var(--emp-color);
					border-bottom: 0.15rem solid var(--emp-color);
					content: "";
				}
			}
		}

		+ label {
			display: inline-block;
			width: 100%;
			padding: 9px 15px;
			border: 1px solid var(--line-color);
			border-radius: 8px;
			background-color: #fff;
			box-sizing: border-box;
			overflow: hidden;
		}
	}
	+ li {
		margin-left: 2px;
	}
`;

const FloatArea = styled.div`
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 10;

	> button {
		height: 55px;
	}
`;

const FilterTagBox = styled.div`
	display: flex;
	align-items: center;
	height: 45px;
	padding-left: 10px;
	border-top: 1px solid var(--line-color);
	background-color: #f7f7f7;

	> span {
		display: flex;
		gap: 7px;
		font-size: 0;
		&:before {
			display: inline-block;
			width: 15px;
			height: 15px;
			background: url(${SpriteImage}) -222px 0 / 400px 400px;
			content: "";
		}
	}
	> button {
		flex: 0 0 auto;
		padding-right: 10px;
		margin-right: 10px;
		font-size: 14px;
		color: var(--default-color);
		border-right: 1px solid var(--line-color);
	}
`;

const TagList = styled.ul`
	display: flex;
	align-items: center;
	gap: 15px;
	overflow-x: auto;
	height: 100%;
`;
const TagListItem = styled.li`
	display: flex;
	align-items: center;
	flex: 0 0 auto;
	font-size: 14px;

	button {
		position: relative;
		width: 10px;
		height: 10px;
		background-color: transparent;

		&::before,
		&::after {
			position: absolute;
			top: 0;
			right: 0px;
			display: block;
			width: 1px;
			height: 12px;
			background-color: var(--emp-color);
			content: "";
		}
		&::before {
			transform: rotate(45deg);
		}
		&::after {
			transform: rotate(-45deg);
		}
	}
	&:last-child {
		padding-right: 10px;
	}
`;

export {
	AccordionArea,
	AccordionContent,
	AccordionDetail,
	AccordionItem,
	AccordionMoreButton,
	AccordionTitle,
	CalendarInput,
	CheckList,
	CheckListItem,
	ContentWrap,
	FilterTagBox,
	FloatArea,
	InputWrap,
	TagList,
	TagListItem,
	Wrap,
};
